// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type React from "react";
import { cn } from "@/lib/utils";

type WizardPaneVariant = "default" | "destructive";

interface WizardPaneProps {
  variant?: WizardPaneVariant;
  icon?: React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
  children?: React.ReactNode;
}

const variantStyles: Record<
  WizardPaneVariant,
  { pane: string; border: string; iconColor: string; shadowClass: string }
> = {
  default: {
    pane: "wizard-pane",
    border: "border-(--wizard-edge)",
    iconColor: "text-(--wizard-icon)",
    shadowClass: "wizard-icon-shadow-default",
  },
  destructive: {
    pane: "wizard-pane-destructive",
    border: "border-red-200 dark:border-red-900",
    iconColor: "text-red-500 dark:text-red-700",
    shadowClass: "wizard-icon-shadow-destructive",
  },
};

export function WizardPane({ variant = "default", icon: Icon, children }: WizardPaneProps) {
  const styles = variantStyles[variant];

  return (
    <div className={cn("w-36 shrink-0 border-r", styles.pane, styles.border)}>
      {Icon && (
        <div className="flex items-center justify-end h-[18px] mt-[23px] pr-6">
          <Icon className={cn("h-5 w-5", styles.iconColor, styles.shadowClass)} />
        </div>
      )}
      {children}
    </div>
  );
}
